import React from 'react';
import { Timeline } from 'shared-components';

// User-facing phases of the financing flow. Each phase maps to one or
// more routes (see getLoanPhaseIndex below). The label order matches the
// natural completion order so the timeline reads top-to-bottom for the
// applicant.
export const LOAN_WIZARD_PHASES = [
  { id: '1', label: 'Financing Amount' },
  { id: '2', label: 'Your Information' },
  { id: '3', label: 'Business Information' },
  { id: '4', label: 'Tax Information' },
  { id: '5', label: 'Financing Type' },
  { id: '6', label: 'Owner Information' },
  { id: '7', label: 'Review' },
];

// Map a loan-flow URL path to the corresponding phase index (0-based).
// Unknown paths fall back to 0 so the timeline still renders.
// More-specific business sub-paths come BEFORE the generic
// `/app/business/` fallback so e.g. `/app/business/further-details`
// resolves to the Tax phase, not the Business Information phase.
export const getLoanPhaseIndex = (pathname?: string): number => {
  if (!pathname) return 0;
  if (pathname.startsWith('/app/amount')) return 0;
  if (pathname.startsWith('/app/info') || pathname.startsWith('/app/create')) return 1;
  if (pathname.startsWith('/app/business/further-details')) return 3;
  if (pathname.startsWith('/app/business/owners')) return 5;
  if (pathname.startsWith('/app/business/more-details')) return 2;
  if (
    pathname.startsWith('/app/type-of-funding') ||
    pathname.startsWith('/app/aproximate-timing') ||
    pathname.startsWith('/app/when-funding-needed') ||
    pathname.startsWith('/app/bank-connect')
  ) {
    return 4;
  }
  if (pathname.startsWith('/app/funding-is-almost-here')) return 6;
  // Any other `/app/business/*` page (catch-all for property-edit
  // routes) groups under Business Information.
  if (pathname.startsWith('/app/business/')) return 2;
  return 0;
};

interface LoanTimelineProps {
  currentStep: number;
}

export const LoanTimeline: React.FC<LoanTimelineProps> = ({ currentStep }) => (
  <div className="pb-[20px] pt-[10px] px-[20px] mx-[20px] border-b border-dawn2">
    <Timeline steps={LOAN_WIZARD_PHASES} currentStep={currentStep} containerProps={{ className: 'py-0' }} />
  </div>
);
